import { List, Text } from "@mantine/core";
import "./ExtensionPopoverContent.scss";
import demo from "@assets/extension-demo.gif";
import { article_url, download_url } from "@/utils/constants/Extension";
import { IconX, IconWand } from "@tabler/icons-react";
import { openNewTab } from "@/utils/browserUtils";
interface ExtensionPopoverContentProps {
  onClose: () => void;
}

const ExtensionPopoverContent: React.FC<ExtensionPopoverContentProps> = ({
  onClose,
}) => {
  return (
    <div className="extension-popover">
      <img className="extension-demo" src={demo} alt="demo" />
      <button
        className="close-button"
        onClick={onClose} // This will close the popover
      >
        <IconX size={24} />
      </button>
      <div className="instructions">
        <div className="instructions-title-container">
          <IconWand />
          <h3 className="instructions-title">
            Let SmartSync do its <span className="magic">magic</span>
          </h3>
        </div>
        <List className="instructions-list" spacing="5" type="ordered">
          <List.Item>
            <Text>
              Click SmartSync to copy your client
              <br />
              data.
            </Text>
          </List.Item>
          <List.Item>
            <Text>Open the SmartSync Chrome Extension.</Text>
            <Text
              onClick={() => openNewTab(download_url)}
              className="download-link"
              td="underline"
            >
              Click here to download.
            </Text>
          </List.Item>
          <List.Item>
            <Text>
              Click <b>Import from SmartWiz</b>
            </Text>
          </List.Item>
          <List.Item>
            <Text>
              Navigate to the applicable form in your <br />
              tax software.
            </Text>
          </List.Item>
          <List.Item>
            <Text>
              Click <b>Export</b> to transfer your client data.
            </Text>
          </List.Item>
        </List>
        <span className="need-more-help">
          <Text>Need more help?</Text>
          <Text
            onClick={() => openNewTab(article_url)}
            className="article-link"
            td="underline"
          >
            Check out this article.
          </Text>
        </span>
      </div>
    </div>
  );
};

export default ExtensionPopoverContent;
